import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// TypeScript interface for React DevTools
declare global {
  interface Window {
    __REACT_DEVTOOLS_GLOBAL_HOOK__?: {
      checkDCE: () => void;
      onCommitFiberRoot: () => void;
      onCommitFiberUnmount: () => void;
    };
  }
}

// Disable React DevTools in production and prevent style injection
if (typeof window !== 'undefined') {
  // Disable React DevTools
  // eslint-disable-next-line no-underscore-dangle
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    /* eslint-disable no-underscore-dangle, @typescript-eslint/no-empty-function */
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE = () => {};
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot = () => {};
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount = () => {};
    /* eslint-enable no-underscore-dangle, @typescript-eslint/no-empty-function */
  }

  // Override any CSS variable injection
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        const target = mutation.target as HTMLElement;
        if (target.style.cssText.includes('native-dark')) {
          // Remove native-dark CSS variables
          target.style.cssText = target.style.cssText.replace(
            /--native-dark[^;]+;?/g,
            '',
          );
        }
      }
    });
  });

  observer.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style'],
  });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
